module.exports = "<div class=\"tobaccoBanner\">\r\n    <img class=\"tobaccoBanner-image\"\r\n        ng-src=\"{{$ctrl.imagePath}}\"\r\n        alt=\"Quitting Smoking Will Improve Your Health\">\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/banners/tobacco-banner.component.html
// module id = 114
// module chunks = 0 2